var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.658%",
    y1: "37.655%",
    x2: "64.118%",
    y2: "124.4%",
    id: "cmwyg1dlka"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.775%",
    y1: "29.063%",
    x2: "61.214%",
    y2: "104.921%",
    id: "lq2jretymb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16528C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.022%",
    y1: "23.288%",
    x2: "56.648%",
    y2: "122.481%",
    id: "7kmfak0mhc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32a15.94 15.94 0 0 0 5.6-1.027V1.027A15.94 15.94 0 0 0 16 0a15.94 15.94 0 0 0-5.6 1.027v29.945A15.922 15.922 0 0 0 16 32z",
    fill: "url(#cmwyg1dlka)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 30.973V1.027C4.33 3.3 0 9.137 0 16c0 6.863 4.33 12.7 10.4 14.973z",
    fill: "url(#lq2jretymb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-6.863-4.33-12.7-10.4-14.973v29.945C27.67 28.7 32 22.863 32 16z",
    fill: "url(#7kmfak0mhc)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.13d0c40e28c64d880e289ffc2dd1f86c.svg";
export { ForwardRef as ReactComponent };